import { forwardRef, useId } from "react";

import { InputWrapper } from "../InputWrapper";
import { InputAlerts, type InputAlertsProps } from "../InputAlerts";
import { InputLabelRight, type InputLabelRightProps } from "../InputLabelRight";
import { RadioBase, type RadioBaseProps } from "../RadioBase";
import { buildAlertAssociationProps } from "../Alert/AlertAssociationProps";

export type RadioProps = Omit<RadioBaseProps, "children"> & {
  labelProps: Omit<InputLabelRightProps, "children">;
  alertProps?: InputAlertsProps["alerts"][number] | InputAlertsProps["alerts"];
};

const Radio = forwardRef<HTMLInputElement, RadioProps>((props, ref) => {
  const { labelProps, alertProps, ...inputProps } = props;
  const { testID = "radio" } = inputProps;

  const alertId = useId();
  const ariaAlertAssociationProps = buildAlertAssociationProps(alertId, props);

  return (
    <InputWrapper
      alert={
        alertProps && (
          <div id={alertId} data-testid={`${testID}-alerts`}>
            <InputAlerts
              alerts={Array.isArray(alertProps) ? alertProps : [alertProps]}
            />
          </div>
        )
      }
    >
      <InputLabelRight {...labelProps}>
        <RadioBase {...inputProps} {...ariaAlertAssociationProps} ref={ref} />
      </InputLabelRight>
    </InputWrapper>
  );
});

Radio.displayName = "Radio";

export default Radio;
